import React, { useState, useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby"
import '../../sass/components/_components.alertBanner.scss';
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";

const AlertBanner = () => {
    const data = useStaticQuery(graphql
        `{
            allWordpress {
              nodes {
                themeSettings {
                  navigationElements {
                    addAlertBanner
                    alertBannerType
                    alertBannerTeaser
                    alertBannerLink {
                      target
                      title
                      url
                    }
                    alertBannerBackgroundColor
                    selectTheRequiredLayout
                    alertIcon {
                      altText
                      gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                    }
                  }
                }
              }
            }
          }          
        `)

    const [hideAlert, setHideAlert] = useState(false);

    useEffect(() => {
        hideAlertCheck(false);
    }, []);

    const hideAlertCheck = (val) => {
        setHideAlert(val);
    }

    return (
        <>
            {data.allWordpress.nodes[0].themeSettings.navigationElements.addAlertBanner === 'yes' && !hideAlert &&
                <>
                    <div className={`cp-alertBanner ${data.allWordpress.nodes[0].themeSettings.navigationElements.selectTheRequiredLayout}`} style={{ backgroundColor: data.allWordpress.nodes[0].themeSettings.navigationElements.alertBannerBackgroundColor ? data.allWordpress.nodes[0].themeSettings.navigationElements.alertBannerBackgroundColor : "#7C4FFF" }}>
                        <div className="cp-alertBanner__inner l--flex">
                            {data.allWordpress.nodes[0].themeSettings.navigationElements.selectTheRequiredLayout === 'layout2' &&
                                <>
                                    {data.allWordpress.nodes[0].themeSettings.navigationElements.alertIcon &&
                                        <GatsbyImage image={getImage(data.allWordpress.nodes[0].themeSettings.navigationElements.alertIcon.gatsbyImage)} alt={data.allWordpress.nodes[0].themeSettings.navigationElements.alertIcon.altText} />
                                    }
                                </>
                            }
                            {data.allWordpress.nodes[0].themeSettings.navigationElements.selectTheRequiredLayout === 'layout1' &&
                                <>
                                    {data.allWordpress.nodes[0].themeSettings.navigationElements.alertBannerType &&
                                        <span className="cp-alertBanner__inner-type" dangerouslySetInnerHTML={{ __html: data.allWordpress.nodes[0].themeSettings.navigationElements.alertBannerType }} />
                                    }
                                </>
                            }
                            {data.allWordpress.nodes[0].themeSettings.navigationElements.alertBannerTeaser &&
                                <p dangerouslySetInnerHTML={{ __html: data.allWordpress.nodes[0].themeSettings.navigationElements.alertBannerTeaser }} />
                            }
                            {data.allWordpress.nodes[0].themeSettings.navigationElements.alertBannerLink &&
                                <a href={data.allWordpress.nodes[0].themeSettings.navigationElements.alertBannerLink.url} target={data.allWordpress.nodes[0].themeSettings.navigationElements.alertBannerLink.target}>{data.allWordpress.nodes[0].themeSettings.navigationElements.alertBannerLink.title}</a>
                            }
                            <button onClick={() => hideAlertCheck(true)}>
                                <StaticImage src="../../images/alert-close.svg" alt="close alert" />
                            </button>
                        </div>
                    </div>
                    <button onClick={() => hideAlertCheck(true)} className="l-alertBackground"></button>
                </>
            }
        </>
    )
};

export default AlertBanner;